<template>
  <div class="fy-fs-list">
    <div
      v-for="(opt, i) in opts"
      :key="`fy-fs-${i}`"
      class="fy-fs-el text-gray clickable translate"
      :class="{disabled: disabledItems.includes(i)}"
      :style="{'margin-bottom': i + 1 !== opts.length ? marginBottom : ''}"
      @click="selectedOption(i)"
    >
      <div class="fy-fs-circle">
        <div
          v-if="selected === i"
          class="fy-fs-checked"
        />
      </div>
      {{ opt }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'FygrSelector',
  props: {
    marginBottom: {
      type: String,
      default: '',
    },
    opts: {
      type: Array,
      default: () => [],
    },
    disabledItems: {
      type: Array,
      default: () => [],
    },
    modelValue: {required: false, default: () => 0, type: Number},
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: 0,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue) {
        if (newValue !== null && newValue !== undefined) {
          this.selected = newValue;
        }
      },
    },
  },
  methods: {
    selectedOption(i) {
      if (!this.disabledItems.includes(i)) {
        this.selected = i;
        this.$emit('update:modelValue', i);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@use 'sass:color';
.fy-fs-list {
  display: flex;
  flex-direction: column;
  .fy-fs-el {
    display: flex;
    align-items: center;
    &.disabled {
      opacity: 50%;
      cursor: not-allowed;
    }
    &:hover {
      .fy-fs-circle {
        border: 1px solid color.adjust($gray, $lightness: -10%);
        .fy-fs-checked {
          background-color: color.adjust($orange, $lightness: -5%);
        }
      }
    }
    .fy-fs-circle {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid $gray;
      border-radius: 50%;
      height: var(--px15);
      width: var(--px15);
      min-width: var(--px15);
      margin-right: var(--px10);
      margin-bottom: var(--px2);
      .fy-fs-checked {
        height: var(--px9);
        width: var(--px9);
        background-color: $orange;
        border-radius: 50%;
      }
    }
  }
}
</style>
